<template>
  <div class="form form-card">
    <div class="form-card__container form-card__container--sm">
      <el-form
        v-show="IsNowType === 1"
        ref="MemberForgetAccountForm"
        class="forgot-account__form"
        :model="MemberForgetAccountForm"
        :rules="MemberForgetAccountRules"
        @submit.prevent.native
      >
        <el-form-item prop="memberMail" class="form-field">
          <label class="form-label">{{ $t('forgotAccount.label.email') }}</label>
          <el-input
            v-model="MemberForgetAccountForm.memberMail"
            :placeholder="$t('forgotAccount.placeholder.email')"
            type="email"
            size="large"
            prefix-icon="el-icon-message"
          />
        </el-form-item>

        <el-form-item prop="memberPhone" class="form-field">
          <label class="form-label">{{ $t('forgotAccount.label.phone') }}</label>
          <el-input
            v-model="MemberForgetAccountForm.memberPhone"
            :placeholder="$t('forgotAccount.placeholder.phone')"
            type="tel"
            size="large"
            prefix-icon="el-icon-phone"
          />
        </el-form-item>

        <div class="form-group form-group--inline">
          <el-form-item prop="captchaCode" class="form-field form-field--flex">
            <label class="form-label">{{ $t('common.label.captcha') }}</label>
            <el-input
              v-model="MemberForgetAccountForm.captchaCode"
              :placeholder="$t('common.placeholder.captcha')"
              type="text"
              size="large"
              prefix-icon="el-icon-picture"
            />
          </el-form-item>
          <div class="captcha-image" @click="GetCaptchaCode">
            <img :src="`data:image/png;base64,${CodeImg}`" alt="Captcha" />
          </div>
        </div>

        <button
          class="btn-submit full"
          @click="MemberForgetAccount"
        >
          {{ $t('common.button.submit') }}
        </button>

        <div class="form-footer">
          <router-link to="/login" class="form-link form-link--primary">
            <i class="el-icon-back"></i>
            {{ $t('forgot.link.backToLogin') }}
          </router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { MemberForgetAccount } from '@/api/MemberApi';
import { GetCaptchaCode, GetCaptchaBase64 } from '@/api/CaptchaApi';

export default {
  data() {
    return {
      IsNowType: 1,
      timeOutProcessId: null,
      time: 60,
      isDisabled: false,
      CaptchaCodeTxt: '發送驗證碼',
      CodeImg: '',
      MemberForgetAccountForm: {
        memberMail: '',
        memberPhone: '',
        code: '',
        captchaCode: '',
      },
      MemberForgetAccountRules: {
        // 檢查輸入的值規則
        memberMail: [{ required: true, message: this.$t('validation.emailRequired'), trigger: 'blur' }],
        // 檢查輸入的值規則
        memberPhone: [{ required: true, message: this.$t('validation.phoneRequired'), trigger: 'blur' }],
      },
    };
  },
  created() {
    this.GetCaptchaCode();
  },
  methods: {
    // 取得驗證碼
    GetCaptchaCode() {
      GetCaptchaCode().then((response) => {
        if (response.data.statusCode === 0) {
          this.MemberForgetAccountForm.code = response.data.data.code;
          GetCaptchaBase64(this.MemberForgetAccountForm.code).then((res) => {
            this.CodeImg = res.data;
          });
        }
      });
    },
    MemberForgetAccount() {
      this.$refs.MemberForgetAccountForm.validate((valid) => {
        if (valid) {
          MemberForgetAccount(this.MemberForgetAccountForm).then((response) => {
            if (response.data.statusCode === 0) {
              this.IsNowType = 1;
              this.MemberForgetAccountForm.captchaCode = ''; // 清空資料
              this.MemberForgetAccountForm.memberMail = ''; // 清空資料
              this.MemberForgetAccountForm.memberPhone = ''; // 清空資料
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('forgotAccount.message.success'),
              });
              this.$router.push('/Login');
            } else {
              this.GetCaptchaCode();
              this.IsNowType = 1;
              this.MemberForgetAccountForm.captchaCode = ''; // 清空資料
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
// nona
</style>
